import React from 'react';
import type { ILeaguePlayerCard } from '../types/players';
import { formatRoleLabel, getPlayerInitials } from '../constants';

interface PlayerRosterListViewProps {
  players: ILeaguePlayerCard[];
}

const PlayerRosterListView: React.FC<PlayerRosterListViewProps> = ({ players }) => {
  return (
    <div className="player-roster-list-wrap">
      <table className="player-roster-list">
        <thead>
          <tr>
            <th>Player</th>
            <th>Team</th>
            <th>Role</th>
            <th>Matches</th>
            <th>Runs</th>
            <th>Wickets</th>
          </tr>
        </thead>
        <tbody>
          {players.map((player) => {
            const fullName = [player.playerFirstName, player.playerLastName].filter(Boolean).join(' ') || '—';
            const roleLabel = formatRoleLabel(player.playerRole);
            return (
              <tr key={player.playerId}>
                <td>
                  <div className="player-roster-list__player">
                    <span className="player-roster-list__avatar" aria-hidden>
                      {getPlayerInitials(player.playerFirstName, player.playerLastName)}
                    </span>
                    <div className="player-roster-list__identity">
                      <div className="player-roster-list__name">{fullName}</div>
                      {player.playerCode && (
                        <div className="player-roster-list__code">{player.playerCode}</div>
                      )}
                    </div>
                  </div>
                </td>
                <td>{player.teamName ?? '—'}</td>
                <td>
                  {roleLabel ? <span className="player-roster-list__role-badge">{roleLabel}</span> : '—'}
                </td>
                <td>{player.totalMatches}</td>
                <td>{player.totalRuns}</td>
                <td>{player.totalWickets}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PlayerRosterListView;
